<app-header></app-header>


<div class="min-h-screen flex items-center short:items-start justify-center px-4 sm:px-6 md:px-8 short:pt-24 short:pb-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employee-login.png)' }">

    <div class="bg-white p-4 sm:p-6 md:p-8 short:py-3 rounded-lg w-full max-w-2xl mt-4 short:mt-0 card-shadow">
        <div class="flex justify-start mb-4 sm:mb-6 short:mb-2 pb-2 short:pb-1 border-b-[1px] ">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14 short:h-10" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ 'EMPLOYEE.LOGIN.LOGIN' | translate }}
        </h2>

        <div>
            <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 short:mb-2 font-light">
                {{ 'EMPLOYEE.LOGIN.LOGIN_DESCRIPTION' | translate }}
            </p>
            <div class="flex justify-center">
                <div class="w-full max-w-md px-2 sm:px-0">
                    <div class="mb-3 sm:mb-4 short:mb-2">
                        <div class="flex flex-col sm:flex-row sm:justify-between mb-2 sm:mb-4 short:mb-1 gap-2">
                            <label class="block text-gray-400 font-light italic text-base sm:text-lg">{{
                                'EMPLOYEE.LOGIN.EMAIL_ADDRESS' | translate }}</label>
                            <!-- <a routerLink="/employee/account/username"
                                class="text-sm text-red-500 hover:underline font-light">
                                {{ 'EMPLOYEE.LOGIN.FORGOT_EMAIL' | translate }}</a> -->
                        </div>

                        <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none"
                            [(ngModel)]="email"
                            placeholder="{{ 'EMPLOYEE.LOGIN.EMAIL_ADDRESS' | translate }}" (blur)="validateEmail()"
                            tabindex="1" (keydown.enter)="isFormValid() && login()" />
                        <div *ngIf="emailTouched && emailErrors.length > 0" class="mt-1">
                            <div *ngFor="let error of emailErrors" class="text-red-500 text-xs sm:text-sm">
                                {{ error | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="mb-4 sm:mb-6 short:mb-3">
                        <div class="flex flex-col sm:flex-row sm:justify-between mb-2 sm:mb-4 short:mb-1 gap-2">
                            <label class="block text-gray-400 font-light italic text-base sm:text-lg">{{
                                'EMPLOYEE.LOGIN.PASSWORD' | translate }}</label>
                            <a routerLink="/employee/account/password"
                                class="text-[0.65rem] text-red-500 hover:underline font-light min-h-[44px] inline-flex items-center">
                                {{ 'EMPLOYEE.LOGIN.FORGOT_PASSWORD' | translate }}</a>
                        </div>
                        <app-password-input
                            [(ngModel)]="password"
                            [placeholder]="'EMPLOYEE.LOGIN.PASSWORD' | translate"
                            [tabindex]="2"
                            (blur)="validatePassword()"
                            (keydown.enter)="isFormValid() && login()">
                        </app-password-input>
                        <div *ngIf="passwordTouched && passwordErrors.length > 0" class="mt-1">
                            <div *ngFor="let error of passwordErrors" class="text-red-500 text-xs sm:text-sm">
                                {{ error | translate }}
                            </div>
                        </div>
                    </div>

                    <!-- Login Error Message -->
                    <div *ngIf="loginError"
                        class="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 text-xs sm:text-sm rounded">
                        {{ loginError }}
                    </div>

                    <button (click)="login()" [disabled]="!isFormValid() || isLoading"
                        class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium relative min-h-[48px]"
                        [ngClass]="{
                            'opacity-50 cursor-default': !isFormValid() || isLoading,
                            'active:bg-red-500 active:text-white': isFormValid() && !isLoading
                        }">
                        <span *ngIf="isLoading"
                            class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <svg class="animate-spin h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </span>
                        <span [ngClass]="{ 'invisible': isLoading }">
                            {{ 'EMPLOYEE.LOGIN.LOGIN_BUTTON' | translate }}
                        </span>
                    </button>
                </div>
            </div>

            <!-- don't have account, signup -->
            <div class="flex justify-center mt-4 sm:mt-6 short:mt-2">
                <div class="text-sm sm:text-base text-gray-500 font-light">{{ 'EMPLOYEE.LOGIN.NO_ACCOUNT' | translate }}
                    <a routerLink="/employee/account/signup" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">{{
                        'EMPLOYEE.LOGIN.SIGNUP' | translate }}</a>
                </div>
            </div>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>